<template>
  <a-modal
    :visible="visible"
    :width="520"
    title="患者实名认证"
    centered
    @cancel="handleCancel"
    :footer="null"
    wrapClassName="realnameAuthContainer"
    :maskClosable="false"
    :bodyStyle="{ padding: '0 0 24px' }"
  >
    <div class="tips">
      <ExclamationCircleFilled
        :style="{ color: '#FF9900', fontSize: '16px', marginRight: '8px' }"
      />
      系统未查询到患者实名信息，请输入患者真实信息进行实名认证。
    </div>
    <div class="box">
      <span class="label">患者姓名：</span>
      <a-input style="width: 224px" v-model:value="formState.name" placeholder="请输入" />
    </div>
    <div class="box">
      <span class="label">身份证号：</span>
      <a-input style="width: 224px" v-model:value="formState.idCard" placeholder="请输入" />
    </div>
    <div class="box">
      <span class="label">手机号码：</span>
      <span style="width: 224px">{{ phoneText }}</span>
    </div>
    <div class="footer">
      <a-button type="primary" @click="handleConfirm">确定</a-button>
    </div>
  </a-modal>
</template>

<script setup>
import { ref, watch, defineProps, defineExpose, defineEmits } from 'vue'
import { ExclamationCircleFilled } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import { patientRealverified } from '@/api/Todo'

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  },
  patientProfileId: {
    type: String,
    default: ''
  },
  phone: {
    type: String,
    default: ''
  }
})
const formState = ref({
  name: '',
  idCard: ''
})
const phoneText = ref('')
const visible = ref(false)

const emit = defineEmits(['handleOk'])

// 患者实名认证
const handleConfirm = async () => {
  try {
    const params = {
      ...formState.value,
      ucUserId: props.data.ucPatientId,
      patientProfileId: props.patientProfileId
    }
    await patientRealverified(params)
    message.success('认证成功')
    visible.value = false
    emit('handleOk')
  } catch (error) {
    message.error(error)
  }
}

const handleCancel = () => {
  visible.value = false
}

const maskPhoneNumber = phoneNumber => {
  // 确保输入是字符串并且长度为11
  if (typeof phoneNumber !== 'string' || phoneNumber.length !== 11) {
    throw new Error('请输入有效的手机号')
  }
  // 使用正则表达式进行脱敏处理
  return phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
}

const setVisible = data => {
  visible.value = data
}

watch(
  () => props.phone,
  val => {
    phoneText.value = maskPhoneNumber(val)
  }
)

defineExpose({
  setVisible
})
</script>

<style scoped lang="scss">
.realnameAuthContainer {
  .tips {
    display: flex;
    align-items: center;
    height: 40px;
    font-size: 14px;
    color: #262626;
    background-color: #fff9e6;
    margin-bottom: 32px;
    padding-left: 16px;
  }
  .box {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 24px;
    .label {
      font-size: 14px;
      color: #595959;
    }
    input {
      border: 1px solid #00000026;
      border-radius: 4px;
    }
  }
  .footer {
    text-align: center;
    button {
      width: 80px;
      background-color: #1890ff;
      border-radius: 4px;
    }
  }
}
</style>
